angular.module('lf.common')

.directive('superform', function ($parse, gtmService) {

  var superform = {
    restrict: 'A',
    require: 'form',
    link: function (scope, el, attrs, FormCtrl) {
      var client = lf.data.xhr.client;
      var $submitButton = el.find('button[type=submit]');
      var submitFn;
      var errorFn;
      
      var defaults = {
        scrollToFirstInvalidField: true,
        scrollable: 'auto'
      };
      
      var superformOptions = $parse(attrs.superformOptions)(scope);
      var opts = $.extend({}, defaults, superformOptions);
      
      if (attrs.superformSubmit) {
        submitFn = $parse(attrs.superformSubmit, /* interceptorFn */ null, /* expensiveChecks */ true);
      }
      
      if (attrs.superformError) {
        errorFn = $parse(attrs.superformError, /* interceptorFn */ null, /* expensiveChecks */ true);
      }

      el.on('submit', function (e) {
        FormCtrl.$touched = true;

        // We need to force an event(s) on which angular commit ng-model values
        // This also fixes autofill issues where Angular doesn't know about autofilled inputs
        var inputsSelector = 'input:not([type=hidden]):not([type=submit]):not([type=reset]), select, textarea';
        if (attrs.ngModelOptions) {
          var event = scope.$eval(attrs.ngModelOptions).updateOn;
          el.find(inputsSelector).trigger(event);
        } else {
          el.find(inputsSelector)
            .trigger('blur')
            .trigger('input')
            .trigger('change')
            .trigger('keydown');
        }

        scope.$digest();

        if (el.hasClass('ng-invalid')) {
          e.preventDefault();
          
          if (opts.scrollToFirstInvalidField) {
            setTimeout(scrollToFirstInvalidField, 50);
          }

          setTimeout(gaTrackErrors, 100);
          
          if (errorFn) {
            scope.$apply(function () {
              errorFn(scope, { $error: FormCtrl.$error });
            });
          }
        } else {
          el.find('input:focus').blur();
          
          if (submitFn) {
            scope.$apply(function () {
              submitFn(scope, { $event: e });
            });
          }
        }

      });

      el.on('focus', 'input[name]:not([type=submit])', function (e) {
        var $input = $(e.target);

        var name = $input.attr('name');
        var field = FormCtrl[name];

        if (!field || field.$valid) return;

        $input.on('input', onInput);

        function onInput () {
          if (field.$editing) return;
          field.$editing = true;
          $input.on('blur', onBlur);
          scope.$digest();
        }

        function onBlur () {
          field.$editing = false;
          $input.off('input', onInput);
          $input.off('blur', onBlur);
          scope.$digest();
        }
      });
      
      function scrollToFirstInvalidField () {
        var $firstInvalidField = el.find('.has-error:eq(0)');
        var scrollable;
        
        if (client.isDesktop) {
          var scrollOpts = {
            duration: 600,
            offset: -300
          };

          if (opts.scrollable === 'auto') {
            var node = el[0];
            
            do {
              var overflowY = $(node).css('overflow-y');
              if ((overflowY === 'auto' || overflowY === 'scroll')
                  && (node.scrollHeight > node.clientHeight)) {
                scrollable = node;
                break;
              }
            } while ((node = node.parentNode) && node !== document.body);
            
          } else if (opts.scrollable !== 'html') {
            scrollable = el.closest(opts.scrollable)[0];
          }
          
          if (scrollable) {
            $.extend(scrollOpts, {
              duration: 300,
              container: scrollable
            });
          }
          
          $firstInvalidField.velocity('scroll', scrollOpts);

        } else if (client.isMobile) {
          var scrollableSelector = '[scrollable], .slidein-container.scrollable';
          if (opts.scrollable !== 'auto') {
            scrollableSelector = opts.scrollable;
          } 
          scrollable = $firstInvalidField.closest(scrollableSelector);
          var iscroll = scrollable.length && scrollable.data('iscroll');
          if (iscroll) {
            iscroll.scrollToElement($firstInvalidField[0], 300, 0, true);
          }
        }
      }
      
      function gaTrackErrors () {
        var errorMessages = [];
        var uncaughtedControlsWithErrors = [];
        _.each(FormCtrl.$error, function (errorCtrls, errorkey) {
          switch (errorkey) {
            case 'required':
              errorMessages.push(constructErrorMessage(getErrorFieldsNames(errorCtrls), 'are required'));
              break;
            case 'checkCC':
            case 'cvc':
            case 'postalCode':
            case 'phoneNumber':
              errorMessages.push(constructErrorMessage(getErrorFieldsNames(errorCtrls), 'has invalid format'));
              break;
            default:
              uncaughtedControlsWithErrors = uncaughtedControlsWithErrors.concat(errorCtrls);
              break;
          }
        });
        if (uncaughtedControlsWithErrors.length) {
          errorMessages.push(constructErrorMessage(getErrorFieldsNames(uncaughtedControlsWithErrors), 'has errors'));
        }

        gtmService.pushFormError(FormCtrl.$name, errorMessages);
      }
      
    }
  };
  
  var getErrorFieldsNames = function (controlsList) {
    var fieldsNames = [];
    _.each(controlsList, function (ctrl) {
      if (ctrl) fieldsNames.push(ctrl.$name);
    });

    return fieldsNames;
  };

  var constructErrorMessage = function (fieldsNames, sufix) {
    var message = 'Field';
    message += (fieldsNames.length > 1) ? 's ' : ' ';
    message += fieldsNames.join(', ') +  ' ' + sufix;

    return message;
  }
  
  return superform;
  
});
